import {
  Checkbox,
  DatePicker,
  Flex,
  Form,
  Input,
  message,
  Select,
  Spin,
} from "antd";
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { encodeBase64File } from "../../../../../utils/encodeBase64";
import PatientService from "../../../../../Services/PatientService";
import { PlusOutlined } from "@ant-design/icons";
import {
  clearPatientFilter,
  handleSetPatientRegistrationPayload,
} from "../../../../../Redux/actions/patientActions";
import dayjs from "dayjs";
import {
  fetchStateList,
  fetCountryList,
} from "../../../../../Redux/actions/CommonActions";
import regImg from "../../../../../Assets/RegistrationAssets/Group 1000003096.png";
import { CiCamera } from "react-icons/ci";
import { MdOutlineEdit } from "react-icons/md";
import CommonService from "../../../../../Services/CommonService.js";
import { validatePostalCode } from "../../../../../utils/convertionFunc";

function Index({ handleCancel, handleSave, handleNext }, ref) {
  const [profileImage, setProfileImage] = useState(null);
  const [firstLoad, setFirstLoad] = useState(false);
  const [dob, setDob] = useState();
  const [fields, setFields] = useState({
    firstname: "",
    lastname: "",
    city: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [rpmChecked, setRpmChecked] = useState(false);
  const [sosChecked, setSosChecked] = useState(false);
  const [currPageView, setCurrPageView] = useState(1);
  const [loader, setLoader] = useState(false);
  const [citiesList, setCitiesList] = useState([]);
  const [statesList, setStatesList] = useState([]);
  const cityRequestRef = useRef(0);
  const stateRequestRef = useRef(0);
  const searchTimeoutRef = useRef(null);
  const stateSearchTimeoutRef = useRef(null);
  const formRef = useRef();
  const fileInputRef = useRef(null);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { countries } = useSelector((state) => state.common);
  const { selectedEditPatient, patientFilter } = useSelector(
    (state) => state.patients,
  );
  const bloodgroup = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"];
  const loggedUserObj = sessionStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;
  const { registrationPayload } = useSelector((state) => state.patients);

  const collectValues = async () => {
    if (!formRef.current) return;
    const vals = formRef.current.getFieldsValue();
    const currDate = new Date().toISOString().slice(0, 19).replace("T", " ");

    const basePayload =
      registrationPayload ||
      (selectedEditPatient ? { ...selectedEditPatient } : {});

    const partial = {
      ...basePayload,
      ...(selectedEditPatient && {
        id: selectedEditPatient.id,
        patientId: selectedEditPatient.patientId,
        account_Id: selectedEditPatient.account_Id,
        clinic_Id: selectedEditPatient.clinic_Id,
        userId: selectedEditPatient.userId,
        userName: selectedEditPatient.userName,
        createdBy: selectedEditPatient.createdBy,
        createdDate: selectedEditPatient.createdDate,
      }),
      firstName: vals.firstname || basePayload.firstName || "",
      lastName: vals.lastname || basePayload.lastName || "",
      mobile: vals.mobile || basePayload.mobile || "",
      email: vals.email || basePayload.email || null,
      salutation: vals.salutation || basePayload.salutation || null,
      gender: vals.gender || basePayload.gender || null,
      maritalStatus: vals.maritalStatus || basePayload.maritalStatus || null,
      bloodGroup: vals.bloodGroup || basePayload.bloodGroup || null,
      address1: vals.addressOne || basePayload.address1 || null,
      address2: vals.addressTwo || basePayload.address2 || null,
      city: vals.city || basePayload.city || null,
      state: vals.patientState || basePayload.state || null,
      country: vals.country || basePayload.country || null,
      pinCode: vals.pincode || basePayload.pinCode || null,
      dob: dob || basePayload.dob || null,
      rpmApplicable: rpmChecked ? "Y" : "N",
      sos: sosChecked ? "Y" : "N",
      erContactNo1: vals.erContactNo1 || basePayload.erContactNo1 || "",
      erContactNo2: vals.erContactNo2 || basePayload.erContactNo2 || "",
      erContactNo3: vals.erContactNo3 || basePayload.erContactNo3 || "",
      erContactNo4: vals.erContactNo4 || basePayload.erContactNo4 || "",
      erContactNo5: vals.erContactNo5 || basePayload.erContactNo5 || "",
      modifiedBy: loggedUser?.user?.userId,
      modifiedDate: currDate,
      status: 1,
    };

    if (!selectedEditPatient) {
      partial.account_Id = loggedUser?.user?.account_Id;
      partial.clinic_Id = loggedUser?.user?.clinic_Id;
      partial.userId = loggedUser?.user?.userId;
      partial.userName = loggedUser?.user?.userName;
      partial.createdBy = loggedUser?.user?.userId;
      partial.createdDate = currDate;
    }

    // Attach image data so it carries through the RPM next-step flow
    if (profileImage) {
      const res = await encodeBase64File(profileImage);
      partial.imageName = profileImage.name;
      partial.photoName = profileImage.name;
      partial.photoType = profileImage.type.split("/")[1] || "jpeg";
      partial.photo = res;
    } else if (selectedEditPatient?.photoName) {
      partial.imageName = selectedEditPatient.photoName;
      partial.photoName = selectedEditPatient.photoName;
    }

    dispatch(handleSetPatientRegistrationPayload(partial));
  };

  useImperativeHandle(ref, () => ({
    collectValues: collectValues,
  }));

  useEffect(() => {
    if (!loggedUser) {
      return;
    }
    const payload = {
      status: 1,
    };

    dispatch(fetCountryList(payload));
  }, []);

  useEffect(() => {
    if (selectedEditPatient) {
      setFirstLoad(true);

      formRef.current.setFieldsValue({
        patientId: selectedEditPatient?.patientId,
        userName: selectedEditPatient?.userName,
        salutation: selectedEditPatient?.salutation,
        firstname: selectedEditPatient?.firstName,
        lastname: selectedEditPatient?.lastName,
        email: selectedEditPatient?.email,
        mobile: selectedEditPatient?.mobile,
        gender: selectedEditPatient?.gender,
        maritalStatus: selectedEditPatient?.maritalStatus,
        bloodGroup: selectedEditPatient?.bloodGroup,
        addressOne: selectedEditPatient?.address1,
        addressTwo: selectedEditPatient?.address2,
        city: selectedEditPatient?.city,
        patientState: selectedEditPatient?.state,
        country: selectedEditPatient?.country,
        pincode: selectedEditPatient?.pinCode,
        dob: dayjs(selectedEditPatient?.dob),
        rpmChecked: selectedEditPatient?.rpmApplicable === "Y" ? true : false,
        sosChecked: selectedEditPatient?.sos === "Y" ? true : false,
        erContactNo1: selectedEditPatient?.erContactNo1,
        erContactNo2: selectedEditPatient?.erContactNo2,
        erContactNo3: selectedEditPatient?.erContactNo3,
        erContactNo4: selectedEditPatient?.erContactNo4,
        erContactNo5: selectedEditPatient?.erContactNo5,
      });
      fetchCities({ city_Name: selectedEditPatient?.city });
      fetchStates({ state_Id: selectedEditPatient?.state });
      setDob(selectedEditPatient?.dob);
      setRpmChecked(selectedEditPatient?.rpmApplicable === "Y" ? true : false);
      setSosChecked(selectedEditPatient?.sos === "Y" ? true : false);
      setFirstLoad(false);
    } else {
      setFirstLoad(false);
    }
  }, [selectedEditPatient]);

  useEffect(() => {
    if (fields.firstname) {
      const formattedFirstname =
        fields.firstname.charAt(0).toUpperCase() +
        fields.firstname.slice(1).toLowerCase();
      form.setFieldsValue({ firstname: formattedFirstname });
    }
    if (fields.lastname) {
      const formattedLastname =
        fields.lastname.charAt(0).toUpperCase() +
        fields.lastname.slice(1).toLowerCase();
      form.setFieldsValue({ lastname: formattedLastname });
    }

    if (fields.city) {
      const formattedCityName =
        fields.city.charAt(0).toUpperCase() +
        fields.city.slice(1).toLowerCase();
      form.setFieldsValue({ city: formattedCityName });
    }
  }, [fields]);

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleUserPicChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size <= 1048576) {
      setProfileImage(file);
    } else {
      message.error("Image/file size should be less than or equal to 1 mb !!");
      return;
    }
  };

  const handleDob = (value, valueString) => {
    setDob(valueString);
  };

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const validatePhoneNumber = (number) => /^\d{10,15}$/.test(number);

  const validatePincode = (pin) => /^\d{6}$/.test(pin);

  const handlePatientSave = async () => {
    const {
      salutation,
      firstname,
      lastname,
      email,
      mobile,
      gender,
      maritalStatus,
      bloodGroup,
      addressOne,
      addressTwo,
      city,
      patientState,
      country,
      pincode,
      erContactNo1,
      erContactNo2,
      erContactNo3,
      erContactNo4,
      erContactNo5,
    } = form.getFieldsValue();
    const currDate = new Date().toISOString();
    const date = currDate.split("T")[0];
    const time = currDate.split("T")[1].slice(0, 8);
    const constructedTime = date + " " + time;

    if (!firstname || !lastname || !mobile) {
      message.error("Please fill in all mandatory fields");
      return;
    }

    if (!validatePhoneNumber(mobile)) {
      message.error("Please enter a valid 10-digit mobile number.");
      return;
    }

    if (email && !validateEmail(email)) {
      message.error("Please enter a valid mail id.");
      return;
    }
    if (pincode && country && !validatePostalCode(country, pincode)) {
      message.error("Please enter a valid pincode.");
      return;
    }

    let payload = {};

    if (sosChecked) {
      if (!erContactNo1 || !erContactNo2 || !erContactNo3 || !erContactNo4) {
        message.error("Please fill in all mandatory fields for SOS");
        return;
      }
    }

    if (rpmChecked) {
      await collectValues();
      handleNext();
      return;
    }

    if (selectedEditPatient) {
      payload = {
        ...selectedEditPatient,
        address1: addressOne ? addressOne : null,
        address2: addressTwo ? addressTwo : null,
        bloodGroup: bloodGroup ? bloodGroup : null,
        city: city ? city : null,
        country: country ? country : null,
        dob: dob ? dob : null,
        email: email ? email : null,
        firstName: firstname,
        gender,
        lastName: lastname,
        maritalStatus: maritalStatus ? maritalStatus : null,
        mobile,
        modifiedBy: loggedUser?.user?.userId,
        modifiedDate: constructedTime,
        pinCode: pincode ? pincode : null,
        salutation: salutation ? salutation : null,
        state: patientState ? patientState : null,
        status: 1,
        rpmApplicable: rpmChecked ? "Y" : "N",
        patientChronicConditionsList:
          selectedEditPatient?.patientChronicConditionsList,
        patientDevicesList: selectedEditPatient?.patientDevicesList,
        patientVitalsConfigList: selectedEditPatient?.patientVitalsConfigList,
        patientVitalsRangeList: selectedEditPatient?.patientVitalsRangeList,
        hospitalId: selectedEditPatient?.hospitalId,
        locationId: selectedEditPatient?.locationId,
        uhId: selectedEditPatient?.hospitalId,
        insuranceId1: selectedEditPatient?.insuranceId1,
        insuranceId2: selectedEditPatient?.insuranceId2,
        insuranceName1: selectedEditPatient?.insuranceName1,
        insuranceName2: selectedEditPatient?.insuranceName2,
        patientGroupNumber: selectedEditPatient?.patientGroupNumber,
        height: selectedEditPatient?.height,
        weight: selectedEditPatient?.weight,
        providerName: selectedEditPatient?.providerName,
        providerCode: selectedEditPatient?.providerCode,
        patientRegConsentDtlList: selectedEditPatient?.patientRegConsentDtlList,
        sos: sosChecked ? "Y" : "N",
        erContactNo1: erContactNo1
          ? erContactNo1
          : selectedEditPatient?.erContactNo1,
        erContactNo2: erContactNo2
          ? erContactNo2
          : selectedEditPatient?.erContactNo2,
        erContactNo3: erContactNo3
          ? erContactNo3
          : selectedEditPatient?.erContactNo3,
        erContactNo4: erContactNo4
          ? erContactNo4
          : selectedEditPatient?.erContactNo4,
        erContactNo5: erContactNo5 ? erContactNo5 : "",
      };
    } else {
      payload = {
        account_Id: loggedUser?.user?.account_Id,
        account_Name: null,
        address1: addressOne ? addressOne : null,
        address2: addressTwo ? addressTwo : null,
        bloodGroup: bloodGroup ? bloodGroup : null,
        city: city ? city : null,
        clinic_Id: loggedUser?.user?.clinic_Id,
        clinic_Name: null,
        country: country ? country : null,
        createdBy: loggedUser?.user?.userId,
        createdDate: constructedTime,
        dob: dob ? dob : null,
        email: email ? email : null,
        firstName: firstname,
        gender,
        lastName: lastname,
        loginId: null,
        loginIdAvailableYN: null,
        maritalStatus: maritalStatus ? maritalStatus : null,
        meetingLink: null,
        mobile,
        modifiedBy: loggedUser?.user?.userId,
        modifiedDate: constructedTime,
        parentPatientId: null,
        parentPatientName: null,
        patientId: null,
        patientRegFee: 0,
        patientRegFeeYN: null,
        photo: null,
        photoName: null,
        photoType: null,
        pinCode: pincode ? pincode : null,
        relationCode: null,
        relationDescription: null,
        salutation: salutation ? salutation : null,
        state: patientState ? patientState : null,
        status: 1,
        userId: loggedUser?.user?.userId,
        userName: loggedUser?.user?.userName,
        rpmApplicable: rpmChecked ? "Y" : "N",
        patientChronicConditionsList: [],
        patientDevicesList: [],
        patientVitalsConfigList: {
          bloodGlucose: 0,
          bmi: 1,
          diastolic: 1,
          heartRate: 0,
          height: 1,
          respiratoryRate: 0,
          spo2: 0,
          systolic: 1,
          temperature: 0,
          weight: 1,
          breathing: 1,
          pulse: 1,
          spirometry: 1,
          createdBy: "",
          modifiedBy: "",
          status: 1,
        },
        patientVitalsRangeList: [],
        hospitalId: "",
        locationId: "",
        uhId: "",
        insuranceId1: "",
        insuranceId2: "",
        insuranceName1: "",
        insuranceName2: "",
        patientGroupNumber: "",
        height: 0,
        weight: 0,
        providerName: "",
        providerCode: "",
        patientRegConsentDtlList: [],
        sos: sosChecked ? "Y" : "N",
        erContactNo1: erContactNo1 ? erContactNo1 : "",
        erContactNo2: erContactNo2 ? erContactNo2 : "",
        erContactNo3: erContactNo3 ? erContactNo3 : "",
        erContactNo4: erContactNo4 ? erContactNo4 : "",
        erContactNo5: erContactNo5 ? erContactNo5 : "",
      };
    }

    // Handle profile image: encode to base64 and include both imageName and photoName
    if (profileImage) {
      const res = await encodeBase64File(profileImage);
      payload.imageName = profileImage.name;
      payload.photoName = profileImage.name;
      payload.photoType = profileImage.type.split("/")[1] || "jpeg";
      payload.photo = res;
    } else if (selectedEditPatient?.photoName) {
      // Preserve existing image name on edit when no new file
      payload.imageName = selectedEditPatient.photoName;
      payload.photoName = selectedEditPatient.photoName;
    }
    if (selectedEditPatient) {
      setLoader(true);
      try {
        await PatientService.EditPatientData(payload);
        message.success("Patient Details updated successfully!!");
        setProfileImage(null);
        formRef.current.resetFields();
        setLoader(false);
        handleSave();
        if (patientFilter) dispatch(clearPatientFilter(false));
      } catch (e) {
        setLoader(false);
        console.error(e);
        e && message.error(e.response.data.message);
      }
    } else {
      setLoader(true);
      try {
        await PatientService.AddPatient(payload);
        message.success("Patient created successfully!!");
        setProfileImage(null);
        formRef.current.resetFields();
        handleSave();
        setLoader(false);
      } catch (e) {
        setLoader(false);
        console.error(e);
        e && message.error(e.response.data.message);
      }
    }
  };

  const handleRpmChange = () => {
    setRpmChecked(!rpmChecked);
  };

  const handleSosChange = () => {
    setSosChecked(!sosChecked);
  };

  const fetchCities = async (filterValues) => {
    const requestId = ++cityRequestRef.current;
    const payload = {
      status: 1,
    };

    let finalPayload;

    if (filterValues) {
      finalPayload = {
        ...payload,
        ...filterValues,
      };
    }

    try {
      const res = await CommonService.CitiesList(
        filterValues ? finalPayload : payload,
      );
      if (requestId !== cityRequestRef.current) return;
      setCitiesList(res.data || []);
    } catch (e) {
      console.error(e);
    }
  };

  const fetchStates = async (filterValues) => {
    const requestId = ++stateRequestRef.current;
    const payload = {
      status: 1,
    };

    let finalPayload;

    if (filterValues) {
      finalPayload = {
        ...payload,
        ...filterValues,
      };
    }

    try {
      const res = await CommonService.StatesList(
        filterValues ? finalPayload : payload,
      );
      if (requestId !== stateRequestRef.current) return;
      setStatesList(res.data || []);
    } catch (e) {
      console.error(e);
    }
  };

  const handleSearchCities = async (value) => {
    if (!value) {
      setCitiesList([]);
      return;
    }
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    searchTimeoutRef.current = setTimeout(() => {
      fetchCities({ city_Name: value });
    }, 400);
  };

  const handleStateChange = async (value) => {
    if (!value) {
      setCitiesList([]);
      return;
    }
    setCitiesList([]);
    const payload = {
      state_Id: value,
    };
    try {
      await fetchCities(payload);
    } catch (e) {
      console.error(e);
    }
  };

  const handleSearchStates = async (value) => {
    if (!value) {
      setStatesList([]);
      return;
    }
    if (stateSearchTimeoutRef.current) {
      clearTimeout(stateSearchTimeoutRef.current);
    }

    stateSearchTimeoutRef.current = setTimeout(() => {
      fetchStates({ state_Name: value });
    }, 400);
  };

  const handleCountryChange = async (value) => {
    if (!value) {
      setStatesList([]);
      return;
    }
    setStatesList([]);
    const payload = {
      country_Id: value,
    };
    try {
      await fetchStates(payload);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      {firstLoad ? (
        <div className="min-h-[50vh] flex items-center justify-center mt-[10%]">
          <Flex align="center" gap="middle">
            <Spin size="large" tip="Loading" />
          </Flex>
        </div>
      ) : (
        <>
          <div>
            <Form
              ref={formRef}
              form={form}
              disabled={loader}
              className="w-full border rounded-md"
            >
              {/* ── Header bar: photo + regImg ── */}
              <div className="flex justify-between bg-[#F6FEFF] px-4 py-2 border-b">
                <div
                  className="flex items-center gap-3 cursor-pointer"
                  onClick={handleClick}
                >
                  <div className="relative w-28 h-28">
                    <input
                      type="file"
                      style={{ display: "none" }}
                      onChange={handleUserPicChange}
                      ref={fileInputRef}
                    />

                    {profileImage ? (
                      <>
                        <img
                          src={URL.createObjectURL(profileImage)}
                          alt="Profile"
                          className="w-28 h-28 object-cover rounded-full border"
                        />
                        <div className="mt-1 text-sm text-gray-600">{profileImage.name}</div>
                      </>
                    ) : selectedEditPatient?.photoName ? (
                      <>
                        <img
                          src={
                            process.env.REACT_APP_IMAGE_URL +
                            selectedEditPatient?.photoName
                          }
                          alt="Profile"
                          className="w-28 h-28 object-cover rounded-full border"
                        />
                      </>
                    ) : (
                      <div className="w-28 h-28 flex items-center justify-center rounded-full border bg-gray-100">
                        <span className="text-gray-500">No Image</span>
                      </div>
                    )}
                  </div>

                  <button className="bg-white border px-3 py-1 rounded-md font-semibold text-sm shadow-sm">
                    <span className="flex gap-2 items-center">
                      {profileImage || selectedEditPatient?.photoName ? (
                        <>
                          <MdOutlineEdit /> <span>Edit Photo</span>
                        </>
                      ) : (
                        <>
                          <CiCamera /> <span>Upload Photo</span>
                        </>
                      )}
                    </span>
                  </button>
                </div>

                {/* regImg — hidden on mobile to prevent overflow */}
                <img src={regImg} alt="img" className="hidden md:block" />
              </div>

              {/* Personal Details */}
              <div className="md:text-xl text-base font-medium px-4 my-2">
                Personal Details
              </div>

              <div className="w-full grid md:grid-cols-3 grid-cols-1 gap-4 px-4">
                {/* SALUTATION */}
                <div className="relative">
                  <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                    Salutation
                  </span>
                  <Form.Item name="salutation" className="mt-1">
                    <Select className="rounded-md h-10" allowClear>
                      <Select.Option value="Mr.">Mr</Select.Option>
                      <Select.Option value="Ms.">Ms</Select.Option>
                      <Select.Option value="Mrs.">Mrs</Select.Option>
                    </Select>
                  </Form.Item>
                </div>

                {/* FIRST NAME */}
                <div className="relative">
                  <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                    First Name <span className="text-red-500">*</span>
                  </span>
                  <Form.Item name="firstname" className="mt-1">
                    <Input
                      className="rounded-md px-4 py-2"
                      onChange={(e) => {
                        const value = e.target.value;
                        const formattedValue =
                          value.charAt(0).toUpperCase() +
                          value.slice(1).toLowerCase();
                        setFields((prev) => ({
                          ...prev,
                          firstname: formattedValue,
                        }));
                      }}
                    />
                  </Form.Item>
                </div>

                {/* LAST NAME */}
                <div className="relative">
                  <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                    Last Name <span className="text-red-500">*</span>
                  </span>
                  <Form.Item name="lastname" className="mt-1">
                    <Input
                      className="rounded-md px-4 py-2"
                      onChange={(e) => {
                        const value = e.target.value;
                        const formattedValue =
                          value.charAt(0).toUpperCase() +
                          value.slice(1).toLowerCase();
                        setFields((prev) => ({
                          ...prev,
                          lastname: formattedValue,
                        }));
                      }}
                    />
                  </Form.Item>
                </div>

                {/* MOBILE */}
                <div className="relative">
                  <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                    Mobile <span className="text-red-500">*</span>
                  </span>
                  <Form.Item name="mobile" className="mt-1">
                    <Input
                      maxLength={15}
                      className="rounded-md px-4 py-2"
                      onKeyDown={(e) => {
                        const allowedKeys = [
                          "Backspace",
                          "Delete",
                          "Tab",
                          "ArrowLeft",
                          "ArrowRight",
                        ];
                        if (
                          !/[0-9]/.test(e.key) &&
                          !allowedKeys.includes(e.key)
                        ) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Form.Item>
                </div>

                {/* EMAIL */}
                <div className="relative">
                  <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                    Email
                  </span>
                  <Form.Item name="email" className="mt-1">
                    <Input type="email" className="rounded-md px-4 py-2" />
                  </Form.Item>
                </div>

                {/* DOB */}
                <div className="relative">
                  <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                    Date of Birth
                  </span>
                  <Form.Item name="dob" className="mt-1">
                    <DatePicker
                      className="w-full rounded-md px-2 py-2"
                      format="MM/DD/YYYY"
                      onChange={handleDob}
                      disabledDate={(current) =>
                        current && current > Date.now()
                      }
                    />
                  </Form.Item>
                </div>

                {/* GENDER */}
                <div className="relative">
                  <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                    Gender
                  </span>
                  <Form.Item name="gender" className="mt-1">
                    <Select className="rounded-md h-10" allowClear>
                      <Select.Option value="M">Male</Select.Option>
                      <Select.Option value="F">Female</Select.Option>
                    </Select>
                  </Form.Item>
                </div>

                {/* MARITAL */}
                <div className="relative">
                  <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                    Marital Status
                  </span>
                  <Form.Item name="maritalStatus" className="mt-1">
                    <Select className="rounded-md h-10" allowClear>
                      <Select.Option value="M">Married</Select.Option>
                      <Select.Option value="U">Unmarried</Select.Option>
                    </Select>
                  </Form.Item>
                </div>

                {/* BLOOD GROUP */}
                <div className="relative">
                  <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                    Blood Group
                  </span>
                  <Form.Item name="bloodGroup" className="mt-1">
                    <Select className="rounded-md h-10" allowClear>
                      {bloodgroup.map((b) => (
                        <Select.Option key={b} value={b}>
                          {b}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              </div>

              {/* Address Title */}
              <div className="md:text-xl text-base font-medium px-4 my-2">
                Address Details
              </div>

              {/* Address Fields */}
              <div className="w-full grid md:grid-cols-4 grid-cols-1 gap-4 px-4">
                {/* ADDRESS 1 */}
                <div className="relative">
                  <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                    Address 1
                  </span>
                  <Form.Item name="addressOne" className="mt-1">
                    <Input className="rounded-md px-4 py-2" />
                  </Form.Item>
                </div>

                {/* ADDRESS 2 */}
                <div className="relative">
                  <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                    Address 2
                  </span>
                  <Form.Item name="addressTwo" className="mt-1">
                    <Input className="rounded-md px-4 py-2" />
                  </Form.Item>
                </div>

                {/* COUNTRY */}
                <div className="relative">
                  <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                    Country
                  </span>
                  <Form.Item name="country" className="mt-1">
                    <Select
                      showSearch
                      className="rounded-md h-10"
                      onChange={handleCountryChange}
                      options={countries?.map((country) => {
                        return {
                          label: country.country_Name,
                          value: country.country_Id,
                          key: country.id,
                        };
                      })}
                      filterOption={(input, option) =>
                        option.label
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      allowClear
                    />
                  </Form.Item>
                </div>

                {/* STATE */}
                <div className="relative">
                  <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                    State
                  </span>
                  <Form.Item name="patientState" className="mt-1">
                    <Select
                      showSearch
                      className="rounded-md h-10"
                      options={statesList?.map((state) => {
                        return {
                          label: state.stateName,
                          value: state.stateId,
                          key: state.id,
                        };
                      })}
                      onChange={handleStateChange}
                      onSearch={handleSearchStates}
                      filterOption={false}
                      allowClear
                    />
                  </Form.Item>
                </div>

                {/* CITY */}
                <div className="relative">
                  <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                    City
                  </span>
                  <Form.Item name="city" className="mt-1">
                    <Select
                      showSearch
                      className="rounded-md h-10"
                      options={citiesList?.map((city) => {
                        return {
                          label: city.cityName,
                          value: city.cityName,
                          key: city.id,
                        };
                      })}
                      onSearch={handleSearchCities}
                      filterOption={false}
                      allowClear
                    />
                  </Form.Item>
                </div>

                {/* PINCODE */}
                <div className="relative">
                  <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                    Pincode
                  </span>
                  <Form.Item name="pincode" className="mt-1">
                    <Input
                      className="rounded-md px-4 py-2"
                      onKeyDown={(e) => {
                        const allowedKeys = [
                          "Backspace",
                          "Delete",
                          "Tab",
                          "ArrowLeft",
                          "ArrowRight",
                        ];
                        if (
                          !/[0-9]/.test(e.key) &&
                          !allowedKeys.includes(e.key)
                        ) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Form.Item>
                </div>

                {loggedUser.user.rpmApplicable === "Y" && (
                  <div className="flex gap-2">
                    <Form.Item valuePropName="checked" name="rpmChecked">
                      <Checkbox onChange={handleRpmChange} />
                    </Form.Item>
                    <div className="">
                      <label className="md:text-lg text-base font-medium">
                        RPM
                      </label>
                    </div>
                  </div>
                )}
              </div>

              {sosChecked && (
                <>
                  <div className="">
                    <div className="">
                      <label className="md:text-lg text-base font-medium">
                        Contact 1<span className="text-red-500">*</span>
                      </label>
                    </div>
                    <Form.Item name="erContactNo1">
                      <Input
                        name="mobile"
                        className="md:w-4/5 w-full md:h-8 h-8 outline-none border-2 md:p-2 p-1 rounded-lg"
                        maxLength={10}
                        onKeyDown={(event) => {
                          const allowedKeys = [
                            "Backspace",
                            "Delete",
                            "Tab",
                            "ArrowLeft",
                            "ArrowRight",
                          ];
                          if (
                            !/[0-9]/.test(event.key) &&
                            !allowedKeys.includes(event.key)
                          ) {
                            event.preventDefault();
                          }
                        }}
                      />
                    </Form.Item>
                  </div>

                  <div className="">
                    <div className="">
                      <label className="md:text-lg text-base font-medium">
                        Contact 2<span className="text-red-500">*</span>
                      </label>
                    </div>
                    <Form.Item name="erContactNo2">
                      <Input
                        name="mobile"
                        className="md:w-4/5 w-full md:h-8 h-8 outline-none border-2 md:p-2 p-1 rounded-lg"
                        maxLength={10}
                        onKeyDown={(event) => {
                          const allowedKeys = [
                            "Backspace",
                            "Delete",
                            "Tab",
                            "ArrowLeft",
                            "ArrowRight",
                          ];
                          if (
                            !/[0-9]/.test(event.key) &&
                            !allowedKeys.includes(event.key)
                          ) {
                            event.preventDefault();
                          }
                        }}
                      />
                    </Form.Item>
                  </div>

                  <div className="">
                    <div className="">
                      <label className="md:text-lg text-base font-medium">
                        Contact 3<span className="text-red-500">*</span>
                      </label>
                    </div>
                    <Form.Item name="erContactNo3">
                      <Input
                        name="mobile"
                        className="md:w-4/5 w-full md:h-8 h-8 outline-none border-2 md:p-2 p-1 rounded-lg"
                        maxLength={10}
                        onKeyDown={(event) => {
                          const allowedKeys = [
                            "Backspace",
                            "Delete",
                            "Tab",
                            "ArrowLeft",
                            "ArrowRight",
                          ];
                          if (
                            !/[0-9]/.test(event.key) &&
                            !allowedKeys.includes(event.key)
                          ) {
                            event.preventDefault();
                          }
                        }}
                      />
                    </Form.Item>
                  </div>

                  <div className="">
                    <div className="">
                      <label className="md:text-lg text-base font-medium">
                        Contact 4<span className="text-red-500">*</span>
                      </label>
                    </div>
                    <Form.Item name="erContactNo4">
                      <Input
                        name="mobile"
                        className="md:w-4/5 w-full md:h-8 h-8 outline-none border-2 md:p-2 p-1 rounded-lg"
                        maxLength={10}
                        onKeyDown={(event) => {
                          const allowedKeys = [
                            "Backspace",
                            "Delete",
                            "Tab",
                            "ArrowLeft",
                            "ArrowRight",
                          ];
                          if (
                            !/[0-9]/.test(event.key) &&
                            !allowedKeys.includes(event.key)
                          ) {
                            event.preventDefault();
                          }
                        }}
                      />
                    </Form.Item>
                  </div>

                  <div className="">
                    <div className="">
                      <label className="md:text-lg text-base font-medium">
                        Contact 5 (Medical Contact)
                      </label>
                    </div>
                    <Form.Item name="erContactNo5">
                      <Input
                        name="mobile"
                        className="md:w-4/5 w-full md:h-8 h-8 outline-none border-2 md:p-2 p-1 rounded-lg"
                        maxLength={10}
                        onKeyDown={(event) => {
                          const allowedKeys = [
                            "Backspace",
                            "Delete",
                            "Tab",
                            "ArrowLeft",
                            "ArrowRight",
                          ];
                          if (
                            !/[0-9]/.test(event.key) &&
                            !allowedKeys.includes(event.key)
                          ) {
                            event.preventDefault();
                          }
                        }}
                      />
                    </Form.Item>
                  </div>
                </>
              )}
            </Form>
          </div>

          {/* ── Cancel / Save buttons ── */}
          {/* Mobile: both buttons full width, stacked or side-by-side */}
          {/* Desktop: unchanged (md:min-w-24 md:w-24) */}
          <div className="flex md:flex-row text-center flex-col md:items-center items-end justify-end gap-3 mt-2">
            <button
              disabled={loader}
              className="w-full md:w-24 md:min-w-24 h-10 md:h-8 p-1 bg-white rounded-md border text-brand-primaryColor border-brand-primaryColor font-semibold custom-button-shadow"
              onClick={handleCancel}
            >
              Cancel
            </button>
            {loggedUser.user.rpmApplicable === "Y" ? (
              <button
                disabled={loader}
                className="w-full md:w-24 md:min-w-24 h-10 md:h-8 p-1 custom_filter text-white rounded-md font-semibold disabled:cursor-not-allowed disabled:opacity-50"
                onClick={handlePatientSave}
              >
                {rpmChecked || currPageView !== 1
                  ? "Next"
                  : selectedEditPatient
                    ? "Update"
                    : "Save"}
              </button>
            ) : (
              <button
                disabled={loader}
                className="w-full md:w-24 md:min-w-24 h-10 md:h-8 p-1 custom_filter text-white rounded-md font-semibold disabled:cursor-not-allowed disabled:opacity-50"
                onClick={handlePatientSave}
              >
                {rpmChecked ? "Next" : selectedEditPatient ? "Update" : "Save"}
              </button>
            )}
          </div>
        </>
      )}
    </>
  );
}

export default forwardRef(Index);
